import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslations } from 'shared/translations/useTranslations';
import { Button, Checkbox, Group, Loader, Modal, TextInput } from '@mantine/core';
import { Pencil } from 'tabler-icons-react';
import apiService from 'shared/services/api';
import { useForm } from '@mantine/form';

const EditCategoryModal = ({ categoryId, onFinish, close, placeId }) => {
  const translations = useTranslations();
  const isOpen = !!categoryId;
  const [isSaving, setSaving] = useState<boolean>();
  const [isLoading, setLoading] = useState(false);
  const [isLoaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState();

  const form = useForm({
    initialValues: data,
  });

  const fetchDetails = useCallback(async () => {
    try {
      setLoading(true);
      setLoaded(false);
      const { data } = await apiService({}).get(`places/${placeId}/files-categories/${categoryId}`);
      setData(data);
      form.setValues(data);
      setLoaded(true);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setError(e);
    }
  }, [categoryId, form]);

  useEffect(() => {
    if (categoryId && isOpen) {
      fetchDetails();
    } else {
      form.reset();
      setLoaded(false);
      setLoading(false);
    }
  }, [categoryId, isOpen]);

  const handleSubmit = async formValues => {
    try {
      setSaving(true);
      const body = {
        name: formValues.name,
      };
      await apiService({}).patch(`places/${placeId}/files-categories/${categoryId}`, body);
      close();
      setSaving(false);
      onFinish();
      toast.success(translations.global.changeSuccessful);
    } catch {
      setSaving(false);
      toast.error(translations.global.somethingWentWrong);
    }
  };

  return (
    <>
      <Modal opened={isOpen} onClose={() => close()} title={translations.global.edit}>
        {isLoading && <Loader />}
        {isLoaded && !isLoading && (
          <form onSubmit={form.onSubmit(handleSubmit)}>
            <TextInput
              required
              label={translations.global.name}
              placeholder=""
              {...form.getInputProps('name')}
            />

            <Group position="right" mt="md">
              <Button type="submit" loading={isLoading}>
                {translations.global.save}
              </Button>
              <Button type="button" variant="outline" onClick={() => close()}>
                {translations.global.cancel}
              </Button>
            </Group>
          </form>
        )}
      </Modal>
    </>
  );
};

export default EditCategoryModal;
